// 📂 frontend/src/hooks/useTheme.ts
import { useContext } from 'react';
import { ThemeContext } from '../contexts/ThemeContext';

export const useTheme = () => {
  const context = useContext(ThemeContext);
  
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  
  return context;
};

export const useThemeShortcuts = () => {
  const { setTheme, currentTheme } = useTheme();

  const handleKeyPress = (event: KeyboardEvent) => {
    // Ctrl/Cmd + Shift + T - Schimbă tema
    if ((event.ctrlKey || event.metaKey) && event.shiftKey && event.key === 'T') {
      event.preventDefault();
      
      // Ciclează prin teme
      const themes = ['light', 'dark', 'futuristic'] as const;
      const currentIndex = themes.indexOf(currentTheme);
      const nextIndex = (currentIndex + 1) % themes.length;
      setTheme(themes[nextIndex]);
    }
  };

  return { handleKeyPress };
};